import gql from 'graphql-tag';

export const GET_REPOSTABLE_JOBS = gql`
  query ($after: String, $first: Int) {
    weployer{
      repostableJobs(after: $after, first: $first) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          id
          belongsToCurrentUser
          createdAt
          dressCode
          experience
          jobType
          latestPositionFinishTime
          meetingInstructions
          numberOfPositions
          owner
          isRemote
          startTime
          finishTime
          tasks
          timeRequirements
          title
          location {
            street
            city
            postcode
            state
          }
        }
      }
    }
  }
`;

export const GET_JOBS = gql`
  query ($statuses: [JobStatusEnum!], $ownedBy: JobOwnerEnum, $first: Int, $after: String) {
    weployer{
      jobs(statuses: $statuses, ownedBy: $ownedBy, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          belongsToCurrentUser
          expiryTime
          finishTime
          id
          instant
          isTransferrable
          jobType
          latestPositionFinishTime
          numberOfPositions
          owner
          primarySkill
          isRemote
          startTime
          status
          title
          location {
            city
            country
            state
          }
          positions {
            extendable
            finishTime
            hasPendingExtensionRequests
            hasTimesheetAwaitingApproval
            id
            status
            isFinishingSoon
            weployee {
              id
              contactDetails {
                name
              }
              profileImageUrl
            }
            timesheets {
              id
              approved
              firstEntryDate
              lastEntryDate
            }
          }
        }
      }
    }
  }
`;

export const jobsQueryParams = ({ statuses, ownedBy }) => ({ statuses, ownedBy });
